import React, { useEffect } from "react";
import { Col, DatePicker, Form, Row, Select, TimePicker, Typography } from "antd";
import inputStyles from "../../../../../styles/Custom/Input.module.css";
import PressureSoreTable from "./PressureSoreModal";
import { prophylaxisKeys } from "../../formsKeys";
import useReceptionistMobilePickerProps from "../../../../Receptionist/receptionistMobilePickerProps";
import useIsMobile from "../../../../../hooks/useIsMobile";
import dayjs from "dayjs";
import "../../FormsIp.css";

const ClinicalProgressDeath = ({
  setPressureSorePoints,
  pressureSorePoints,
}) => {
  const isMobile = useIsMobile();
  const form = Form.useFormInstance();
  const mobilePickerProps = useReceptionistMobilePickerProps();
  const deathDatePart = Form.useWatch(
    ["clinical_progress", "death_date_part"],
    form
  );
  const deathTimePart = Form.useWatch(
    ["clinical_progress", "death_time_part"],
    form
  );

  useEffect(() => {
    if (!isMobile) return;
    const deathDate = form.getFieldValue(["clinical_progress", "death_date"]);
    if (!deathDate) return;
    const current = form.getFieldValue("clinical_progress") || {};
    if (current.death_date_part && current.death_time_part) return;
    form.setFieldsValue({
      clinical_progress: {
        ...current,
        death_date_part: dayjs(deathDate),
        death_time_part: dayjs(deathDate),
      },
    });
  }, [isMobile, form]);

  useEffect(() => {
    if (!isMobile) return;
    if (!deathDatePart) {
      form.setFieldValue(["clinical_progress", "death_date"], null);
      return;
    }
    let combined = dayjs(deathDatePart);
    if (deathTimePart) {
      combined = combined
        .hour(dayjs(deathTimePart).hour())
        .minute(dayjs(deathTimePart).minute())
        .second(0);
    }
    form.setFieldValue(["clinical_progress", "death_date"], combined);
  }, [deathDatePart, deathTimePart, isMobile, form]);

  return (
    <>
      <Typography>
        <Typography.Text>
          During his-her stay at the Centre, patient underwent regular
          physiotherapy and other symptomatic and supportive care for his-her
          functional recovery.
        </Typography.Text>
      </Typography>
      <Typography>
        <Typography.Text>He/She received</Typography.Text>
        <Form.Item
          style={{ display: "inline-block" }}
          name={["clinical_progress", "dvt_prophylaxis"]}
        >
          <Select
            options={prophylaxisKeys}
            className={inputStyles.mdInput}
            style={{ width: isMobile ? "100%" : "250px" }}
            placeholder="DVT Prophylaxis"
          />
        </Form.Item>
        <Typography.Text>as DVT Prophylaxis</Typography.Text>
      </Typography>
      <Typography>
        <Typography.Text>
          He/She received regular wound care, with frequent change of
          positioning with medical support for the following Pressure Sores
        </Typography.Text>{" "}
        <PressureSoreTable
          setPressureSorePoints={setPressureSorePoints}
          pressureSorePoints={pressureSorePoints}
        />
        <br />
        <Typography.Text>
          However as the patient&apos;s condition deteriorated on
        </Typography.Text>
        <Form.Item
          style={{ display: "inline-block" }}
          name={["clinical_progress", "date"]}
        >
          <DatePicker
            className={inputStyles.mdDatePicker}
            style={{
              width: isMobile ? "100%" : "150px",
              marginLeft: isMobile ? 0 : 5,
              marginRight: isMobile ? 0 : 5,
            }}
            format="DD/MM/YYYY"
            inputReadOnly
            {...mobilePickerProps}
          />
        </Form.Item>
        <Typography.Text>
          , his/her attendees were explained about the condition and the poor
          prognosis.Patient had a cardio- respiratory arrest. CPR was initiated
          as per ACLS guidelines, but the patient couldn&apos;t be revived. ECG
          was suggestive of isometric line and he/she was pronounced dead at on
        </Typography.Text>
        {isMobile ? (
          <>
            <Form.Item name={["clinical_progress", "death_date"]} hidden>
              <DatePicker />
            </Form.Item>
            <Row gutter={[8, 8]} className="forms-ip-death-datetime">
              <Col span={24}>
                <Form.Item
                  name={["clinical_progress", "death_date_part"]}
                  style={{ marginBottom: 8 }}
                >
                  <DatePicker
                    className={inputStyles.mdDatePicker}
                    style={{ width: "100%" }}
                    format="DD/MM/YYYY"
                    placeholder="Select date"
                    inputReadOnly
                    {...mobilePickerProps}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name={["clinical_progress", "death_time_part"]}
                  style={{ marginBottom: 0 }}
                >
                  <TimePicker
                    className={inputStyles.mdDatePicker}
                    style={{ width: "100%" }}
                    use12Hours
                    format="hh:mm A"
                    placeholder="Select time"
                    inputReadOnly
                    getPopupContainer={() => document.body}
                    placement="bottomLeft"
                    popupClassName="curengo-mobile-time-picker"
                    needConfirm
                  />
                </Form.Item>
              </Col>
            </Row>
          </>
        ) : (
          <Form.Item
            style={{ display: "inline-block" }}
            name={["clinical_progress", "death_date"]}
          >
            <DatePicker
              showTime={{
                use12Hours: true,
                format: "hh:mm A",
              }}
              format="DD/MM/YYYY hh:mm A"
              className={inputStyles.mdDatePicker}
              style={{ width: "200px", marginLeft: 5 }}
              inputReadOnly
              {...mobilePickerProps}
            />
          </Form.Item>
        )}
      </Typography>
    </>
  );
};

export default ClinicalProgressDeath;
